import Vue from 'vue';
import alice from '../../alice-api';

export default {
  namespaced: true,
  state: {
    promotionList: [],
  },
  getters: {
    promotionList: (state) => state.promotionList,
  },
  actions: {
    getPromotion(context, params) {
      const { activeOnly } = params;
      return new Promise((resolve, reject) => {
        alice
          .getPromotion(activeOnly)
          .then((response) => {
            const { data } = response.data;
            context.commit('setPromotionListData', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    createNewPromotion(context, params) {
      const { data } = params;
      return new Promise((resolve, reject) => {
        alice
          .createNewPromotion(data)
          .then((result) => {
            if (result.data.data.id) {
              resolve(result.data.data);
            } else {
              resolve();
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updatePromotion(context, params) {
      const { promotionId, data } = params;
      return new Promise((resolve, reject) => {
        alice
          .updatePromotion(promotionId, data)
          .then(() => {
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deletePromotion(context, params) {
      const { promotionId } = params;
      return new Promise((resolve, reject) => {
        alice
          .deletePromotion(promotionId)
          .then(() => {
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  mutations: {
    setPromotionListData(state, data) {
      Vue.set(state, 'promotionList', data);
    },
  },
};
